<template>
<div class="min-h-screen bg-gray-50 py-12">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-gray-900 mb-4">Điều khoản sử dụng</h1>
        <p class="text-lg text-gray-600">Cập nhật lần cuối: {{ currentDate }}</p>
    </div>

    <!-- Content -->
    <div class="bg-white rounded-lg shadow-lg p-8">
        <div class="prose prose-lg max-w-none">
        <!-- Section 1 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">1. Chấp nhận điều khoản</h2>
            <p class="text-gray-700 leading-relaxed">
            Bằng cách truy cập và sử dụng website này, bạn đồng ý tuân thủ các điều khoản sử dụng sau đây. 
            Nếu bạn không đồng ý với bất kỳ điều khoản nào, vui lòng không sử dụng website.
            </p>
        </div>

        <!-- Section 2 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">2. Mục đích sử dụng</h2>
            <p class="text-gray-700 leading-relaxed">
            Website này được tạo ra để:
            </p>
            <ul class="list-disc list-inside mt-4 text-gray-700 space-y-2">
            <li>Giới thiệu dịch vụ thiết kế web</li>
            <li>Cung cấp thông tin về các gói dịch vụ</li>
            <li>Liên lạc và tư vấn cho khách hàng</li>
            <li>Trưng bày portfolio và case study</li>
            </ul>
        </div>

        <!-- Section 3 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">3. Thông tin liên hệ</h2>
            <p class="text-gray-700 leading-relaxed">
            Khi liên hệ với chúng tôi, bạn cam kết cung cấp thông tin chính xác và đầy đủ. 
            Thông tin sai lệch có thể ảnh hưởng đến chất lượng dịch vụ được cung cấp.
            </p>
        </div>

        <!-- Section 4 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">4. Dịch vụ thiết kế web</h2>
            <p class="text-gray-700 leading-relaxed">
            Các dịch vụ thiết kế web được cung cấp theo hợp đồng riêng biệt với các điều khoản cụ thể về:
            </p>
            <ul class="list-disc list-inside mt-4 text-gray-700 space-y-2">
            <li>Phạm vi công việc và timeline</li>
            <li>Phương thức thanh toán</li>
            <li>Chính sách bảo hành và hỗ trợ</li>
            <li>Quyền sở hữu và bản quyền</li>
            </ul>
        </div>

        <!-- Section 5 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">5. Bản quyền</h2>
            <p class="text-gray-700 leading-relaxed">
            Tất cả nội dung trên website này, bao gồm văn bản, hình ảnh, logo và thiết kế, 
            đều thuộc bản quyền của chúng tôi và được bảo vệ bởi luật bản quyền Việt Nam.
            </p>
        </div>

        <!-- Section 6 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">6. Liên hệ</h2>
            <p class="text-gray-700 leading-relaxed">
            Nếu bạn có thắc mắc về các điều khoản sử dụng này, 
            vui lòng liên hệ với chúng tôi qua email: <span class="font-semibold text-blue-600">contact@webservices.vn</span>
            </p>
        </div>
        </div>
    </div>

    </div>
</div>
</template>

<script setup>
const currentDate = '30/12/2024'
</script>